/**
 * Amenities, grouped from the original's "Our Amenities" list. `id` is the
 * in-page anchor on /services (e.g. /services#water).
 */
export const serviceItems = [
    {
        index: '01',
        id: 'water',
        title: 'On the Water',
        description: 'A small craft boat launch on site and several options for accessing the lake, for sailing, fishing, canoeing, kayaking, and swimming off the dock.',
        chips: ['Boat launch', 'Docks', 'Kayaking'],
        image: '/images/boat-launch-and-dock.jpg',
        alt: "The small craft boat launch, boathouse and dock at Bodin's Resort"
    },
    {
        index: '02',
        id: 'beaches',
        title: 'Beaches',
        description: 'A few short steps to your secluded beach, for swimming, rock skipping, or just relaxing. Walk through the woods to the other beaches.',
        chips: ['Swimming', 'Rock skipping', 'Relaxing'],
        image: '/images/stairs-to-the-beach.jpg',
        alt: 'Wooden stairs leading down through the pines to the Lake Superior shore'
    },
    {
        index: '03',
        id: 'grounds',
        title: 'Under the Pines',
        description: 'Kick back on our spacious grounds under majestic old growth pines, with large fields for many games, a large lawn chess set and short walking trails.',
        chips: ['Lawn chess', 'Field games', 'Walking trails'],
        image: '/images/swing-lake-view.jpg',
        alt: 'A green log swing facing Lake Superior and the Apostle Islands'
    },
    {
        index: '04',
        id: 'fire-pits',
        title: 'Fire Pits & Grills',
        description: 'Fire pits by the water and charcoal or gas grills with every cabin, for evenings when the colors of the sunset reflect off the waters.',
        chips: ['Fire pits', 'Charcoal or gas grills'],
        image: '/images/dusk-on-the-bay.jpg',
        alt: 'Dusk settling over calm water on the bay'
    },
    {
        index: '05',
        id: 'comforts',
        title: 'Cabin Comforts',
        description: 'Air-conditioned units, in-floor heat, fully stocked kitchens and new beds, with linens for each bed and bath towels for each guest. Well behaved pets allowed.',
        chips: ['Air conditioning', 'In-floor heat', 'Linens provided'],
        image: '/images/blue-cabin-living-room.jpg',
        alt: 'Blue Cabin living room with large blue sofas'
    }
]
